import styled from "styled-components";
// import './SearchFilter.css';

const SearchFilter = styled.input`
  width: 800px;
  height: 50px;
  font-size: 2em;
  text-align: center;
`;

export default SearchFilter;
